// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-progress-bar {
  --progress-background: #ed143d;
}

ion-title {
  font-size: 16px !important;
}

ion-toolbar {
  padding-inline: 0 !important;
}

.container {
  padding: 12px;
  display: flex;
  flex-direction: column;
  min-height: 450px;
}
.container .step1-body,
.container .step2-body,
.container .step3-body,
.container .step4-body,
.container .step5-body,
.container .step6-body,
.container .step7-body,
.container .step8-body {
  flex: 1;
}
.container .step-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.container .step-header ion-icon {
  font-size: 24px;
  color: #ed143d;
}
.container .step-header h4 {
  margin: 10px 0;
  font-weight: 600;
}
.container .step1-body {
  display: flex;
  flex-direction: column;
}
.container .step1-body .start-time-picker,
.container .step1-body .end-time-picker {
  display: flex;
  align-items: center;
  justify-content: end;
}
.container .step1-body .start-time-picker ion-chip,
.container .step1-body .end-time-picker ion-chip {
  font-weight: 600;
}
.container .step1-body .start-time-picker span,
.container .step1-body .end-time-picker span {
  margin-right: auto;
}
.container .step2-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.container .step2-body .category-item {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-weight: 600;
  gap: 15px;
}
.container .step2-body .category-item ion-icon {
  font-size: 24px;
}
.container .step2-body .category-item.selected {
  border: 2px solid rgba(237, 20, 61, 0.6392156863);
}
.container .step3-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.container .step3-body .capacity-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.container .step3-body .capacity-section input {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px;
  border-radius: 8px;
  border: none;
  outline: none;
}
.container .step3-body .capacity-section input:focus {
  outline: none;
  border: 2px solid rgba(237, 20, 61, 0.6392156863);
}
.container .step3-body .selected-participants-container {
  margin: 5px 0;
}
.container .step3-body .selected-participants-container .participants-trigger {
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.container .step3-body .selected-participants-container .selected-participants-list {
  max-height: 100px;
  overflow-y: auto;
}
.container .step3-body .selected-participants-container .selected-participants-list ion-chip {
  padding: 0 10px;
  min-height: 25px;
  font-weight: 600;
  font-size: 12px;
}
.container .step4-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.container .step4-body .online-meeting-option {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
}
.container .step4-body .online-meeting-option.selected {
  border: 2px solid rgba(237, 20, 61, 0.6392156863);
}
.container .step5-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.container .step5-body input {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px;
  border-radius: 8px;
  border: none;
  outline: none;
}
.container .step5-body input:focus {
  outline: none;
  border: 2px solid rgba(237, 20, 61, 0.6392156863);
}
.container .step6-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.container .step6-body .reminder-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.container .step6-body .reminder-options .reminder-item {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
}
.container .step6-body .reminder-options .reminder-item.selected {
  border: 2px solid rgba(237, 20, 61, 0.6392156863);
}
.container .step7-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.container .step7-body .summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
}
.container .step7-body .summary-item .key {
  font-weight: 600;
}
.container .step7-body .summary-item:last-child {
  border-bottom: none;
}
.container .step8-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
}
.container .step8-body h6 {
  margin: 0 10px;
  font-weight: 600;
  text-align: center;
}
.container .step8-body ion-spinner {
  margin: 20px auto;
  height: 85px;
  width: 85px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer ion-button {
  color: #666;
}
.footer ion-button::part(native) {
  width: -webkit-fit-content;
  width: fit-content;
  padding: 0;
}
.footer ion-button ion-icon {
  color: #666;
}

ion-datetime::part(month-year-button) {
  color: #ed143d;
  padding-block: 0;
  transform: translateY(-8px);
}

ion-datetime {
  --ion-color-primary: #ed143d;
  padding-top: 8px;
}

ion-datetime::part(calendar-day):focus {
  box-shadow: none;
}

ion-popover.datetime-popover::part(content) {
  --width: 350px;
  --max-width: 90%;
  --height: auto;
}

ion-popover.invitable-participants-popover::part(content) {
  --width: 300px;
}

.alert-message {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 10px 8px;
}

.invitable-participants-list {
  padding: 0 8px 8px;
  max-height: 250px;
  overflow-y: auto;
}
.invitable-participants-list .attendee-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 4px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
}
.invitable-participants-list .attendee-item .attendee-name {
  flex: 1;
}
.invitable-participants-list .attendee-item:hover {
  background-color: rgba(var(--ion-color-danger-rgb), 0.1);
}
.invitable-participants-list .attendee-item ion-icon {
  font-size: 20px;
}
.invitable-participants-list .attendee-item span {
  font-size: 14px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.working-hours-toggle {
  margin-bottom: 16px;
}

ion-toggle {
  display: block;
  margin: 0 auto;
  --track-background-checked: #ed143d;
  width: 100%;
}
ion-toggle ion-label {
  text-wrap: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/booking-stepper/booking-stepper.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;;AACA;EACE,0BAAA;AAEF;;AAAA;EACE,4BAAA;AAGF;;AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAGF;AAFE;;;;;;;;EAQE,OAAA;AAIJ;AAFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAIJ;AAHI;EACE,eAAA;EACA,cAAA;AAKN;AAHI;EACE,cAAA;EACA,gBAAA;AAKN;AAFE;EACE,aAAA;EACA,sBAAA;AAIJ;AAHI;;EAEE,aAAA;EACA,mBAAA;EACA,oBAAA;AAKN;AAJM;;EACE,gBAAA;AAOR;AALM;;EACE,kBAAA;AAQR;AAJE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAMJ;AALI;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AAON;AANM;EACE,eAAA;AAQR;AANM;EACE,iDAAA;AAQR;AAJE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAMJ;AALI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAON;AANM;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAQR;AAPQ;EACE,aAAA;EACA,iDAAA;AASV;AAJI;EACE,aAAA;AAMN;AALM;EACE,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAOR;AALM;EACE,iBAAA;EACA,gBAAA;AAOR;AANQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAQV;AAHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKJ;AAJI;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAMN;AALM;EACE,iDAAA;AAOR;AAHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKJ;AAJI;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAMN;AALM;EACE,aAAA;EACA,iDAAA;AAOR;AAHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKJ;AAJI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAMN;AALM;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAOR;AANQ;EACE,iDAAA;AAQV;AAHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKJ;AAJI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,cAAA;AAMN;AALM;EACE,gBAAA;AAOR;AALM;EACE,mBAAA;AAOR;AAHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AAKJ;AAJI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAMN;AAJI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AAMN;;AAFA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAKF;AAHE;EACE,WAAA;AAKJ;AAJI;EACE,0BAAA;EAAA,kBAAA;EACA,UAAA;AAMN;AAJI;EACE,WAAA;AAMN;;AADA;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;AAIF;;AADA;EACE,4BAAA;EACA,gBAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAIF;;AADA;EACE,cAAA;AAIF;;AAFA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAKF;;AAHA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAMF;AAJE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAMJ;AALI;EACE,OAAA;AAON;AAJI;EACE,wDAAA;AAMN;AAHI;EACE,eAAA;AAKN;AAFI;EACE,eAAA;AAIN;;AACA;EACE,YAAA;EACA,oBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;AAEF;AADE;EACE,eAAA;AAGJ","sourcesContent":["ion-progress-bar {\n  --progress-background: #ed143d;\n}\nion-title {\n  font-size: 16px !important;\n}\nion-toolbar {\n  padding-inline: 0 !important;\n}\n\n.container {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  min-height: 450px;\n  .step1-body,\n  .step2-body,\n  .step3-body,\n  .step4-body,\n  .step5-body,\n  .step6-body,\n  .step7-body,\n  .step8-body {\n    flex: 1;\n  }\n  .step-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n    ion-icon {\n      font-size: 24px;\n      color: #ed143d;\n    }\n    h4 {\n      margin: 10px 0;\n      font-weight: 600;\n    }\n  }\n  .step1-body {\n    display: flex;\n    flex-direction: column;\n    .start-time-picker,\n    .end-time-picker {\n      display: flex;\n      align-items: center;\n      justify-content: end;\n      ion-chip {\n        font-weight: 600;\n      }\n      span {\n        margin-right: auto;\n      }\n    }\n  }\n  .step2-body {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    .category-item {\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n      padding: 10px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      font-weight: 600;\n      gap: 15px;\n      ion-icon {\n        font-size: 24px;\n      }\n      &.selected {\n        border: 2px solid #ed143da3;\n      }\n    }\n  }\n  .step3-body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    .capacity-section {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      input {\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n        padding: 10px;\n        border-radius: 8px;\n        border: none;\n        outline: none;\n        &:focus {\n          outline: none;\n          border: 2px solid #ed143da3;\n        }\n      }\n    }\n\n    .selected-participants-container {\n      margin: 5px 0;\n      .participants-trigger {\n        cursor: pointer;\n        text-decoration: underline;\n        margin-bottom: 8px;\n        display: flex;\n        align-items: center;\n        gap: 5px;\n      }\n      .selected-participants-list {\n        max-height: 100px;\n        overflow-y: auto;\n        ion-chip {\n          padding: 0 10px;\n          min-height: 25px;\n          font-weight: 600;\n          font-size: 12px;\n        }\n      }\n    }\n  }\n  .step4-body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    .online-meeting-option {\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n      padding: 10px;\n      border-radius: 8px;\n      text-align: center;\n      font-weight: 600;\n      &.selected {\n        border: 2px solid #ed143da3;\n      }\n    }\n  }\n  .step5-body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    input {\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n      padding: 10px;\n      border-radius: 8px;\n      border: none;\n      outline: none;\n      &:focus {\n        outline: none;\n        border: 2px solid #ed143da3;\n      }\n    }\n  }\n  .step6-body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    .reminder-options {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 10px;\n      align-items: center;\n      justify-content: center;\n      .reminder-item {\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n        padding: 10px;\n        border-radius: 8px;\n        font-weight: 600;\n        text-align: center;\n        &.selected {\n          border: 2px solid #ed143da3;\n        }\n      }\n    }\n  }\n  .step7-body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    .summary-item {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border-bottom: 1px solid #ccc;\n      padding: 5px 0;\n      .key {\n        font-weight: 600;\n      }\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n  }\n  .step8-body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    justify-content: center;\n    h6 {\n      margin: 0 10px;\n      font-weight: 600;\n      text-align: center;\n    }\n    ion-spinner {\n      margin: 20px auto;\n      height: 85px;\n      width: 85px;\n    }\n  }\n}\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  // margin-top: auto;\n  ion-button {\n    color: #666;\n    &::part(native) {\n      width: fit-content;\n      padding: 0;\n    }\n    ion-icon {\n      color: #666;\n    }\n  }\n}\n\nion-datetime::part(month-year-button) {\n  color: #ed143d;\n  padding-block: 0;\n  transform: translateY(-8px);\n}\n\nion-datetime {\n  --ion-color-primary: #ed143d;\n  padding-top: 8px;\n}\n\nion-datetime::part(calendar-day):focus {\n  box-shadow: none;\n}\n\nion-popover.datetime-popover::part(content) {\n  --width: 350px;\n  --max-width: 90%;\n  --height: auto;\n}\n\nion-popover.invitable-participants-popover::part(content) {\n  --width: 300px;\n}\n.alert-message {\n  font-size: 12px;\n  color: #666;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0 10px 8px;\n}\n.invitable-participants-list {\n  padding: 0 8px 8px;\n  max-height: 250px;\n  overflow-y: auto;\n\n  .attendee-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 4px;\n    font-weight: 600;\n    cursor: pointer;\n    border-radius: 4px;\n    .attendee-name {\n      flex: 1;\n    }\n\n    &:hover {\n      background-color: rgba(var(--ion-color-danger-rgb), 0.1);\n    }\n\n    ion-icon {\n      font-size: 20px;\n    }\n\n    span {\n      font-size: 14px;\n    }\n  }\n}\n\n.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.working-hours-toggle {\n  margin-bottom: 16px;\n}\n\nion-toggle {\n  display: block;\n  margin: 0 auto;\n  --track-background-checked: #ed143d;\n  width: 100%;\n  ion-label {\n    text-wrap: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
